import { themes } from '@weenat/theme';
import { isNil } from 'lodash-es';
import { isKeyOf } from '../utils';
const theme = themes.light;
/**
 * @returns a color based on the metric, or on both metric and horizon if its given, or black if no metric color is defined
 */
export const declineColorForHorizon = (metric, horizon) => {
    const color = theme.colors.metrics[metric]['500'];
    const horizonAsString = !isNil(horizon) ? `${horizon.value}` : undefined;
    let result = '#000000';
    if (color) {
        if (!isNil(horizonAsString) && isKeyOf(horizonAsString, theme.colors.depths)) {
            result = theme.colors.depths[horizonAsString];
        }
        else {
            result = color;
        }
    }
    return result;
};
